
export const VerificationStatuses = {
    Unknown: 0,
    Basic: 1,
    Pending: 2,
    Verified: 3,
    Proxy: 4
}
// corresponts to StatusMaster table
// list is current as of 2026-07-23
export const InternalApplicationStatuses = {
    Draft: 2,
    Submitted: 3,
    AutoApproved: 4,
    InProgress: 5,
    FollowUp: 6,
    Approved: 7,
    Rejected: 8,
    Cancelled: 9,
    EOAuditPending: 10,
    ReadyToSend: 11,
    SentWithAutoAuthorization: 12,
    PaymentAuthorized: 13,
    PaymentOnHold: 14,
    SentBackByEO: 15,
    Withdrawn: 16,
    PaymentProcessing: 17,
    PaymentSent: 18,
    PaymentComplete: 19,
    EOAuthorized:20,
    BatchHeld: 21,
    VoucherIssued: 22,
    BatchSent: 23,
    FailedToSend: 24,
    Closed: 25,
    PaymentFailed: 31,
    PaymentRejected: 32,
    PaymentCancelled: 33,
    PaymentCancellationPending: 34,
    PaymentCancellationRejected: 35,
    PaymentIncomplete: 36,
}

export const StatusTransitionEventEnum = {
    None: 0,
    SubmittedToDraft: 1,
  };

export const VerificationStatusChangeEvent = {
    None: 0,
    BasicToPending: 1,
    BasicToVerified: 2,
};

export const ProgramStatuses = {
    Draft: 0,
    SoftLaunch: 1,
    Open: 2,
    Inactive: 3,
}

export const EventStatuses = {
    Draft: 0,
    Active: 1,
    Inactive: 2,
}

export const constants = {
    InternalStatus: { ...InternalApplicationStatuses},
    VerificationStatus: { ...VerificationStatuses },
    ProgramStatus: { ...ProgramStatuses },
    StatusTransitionEventEnum: { ...StatusTransitionEventEnum },
    VerificationStatusChangeEvent: { ...VerificationStatusChangeEvent },
}